import usePersistedState from "../../../../hooks/usePersistedState";

export default function useFilters(initial = {}, storageKey = null) {
    const [state, setState] = usePersistedState(storageKey, {
        search: initial.search || "",
        filters: initial.filters || {},
        page: 0,
    });

    const setSearch = (value) => {
        setState(prev => ({ ...prev, search: value }));
    };

    const setFilters = (value) => {
        setState(prev => ({
            ...prev,
            filters: typeof value === "function" ? value(prev.filters) : value,
        }));
    };

    const setPage = (value) => {
        setState(prev => ({
            ...prev,
            page: typeof value === "function" ? value(prev.page) : value,
        }));
    };

    const updateFilter = (key, value) => {
        setState(prev => ({
            ...prev,
            filters: { ...prev.filters, [key]: value },
            page: 0,
        }));
    };

    const clearFilters = () => {
        setState(prev => ({ ...prev, filters: {}, page: 0 }));
    };

    return {
        search: state.search,
        setSearch,
        filters: state.filters,
        setFilters,
        updateFilter,
        clearFilters,
        page: state.page,
        setPage,
    };
}
